import React, { useCallback } from 'react';
import { useOpts } from '../context';
import { EventAction } from '../types/events';
import ExitConfirmation from './ExitConfirmation';
import eventQueue from '../events/queue';
import useShowingExitConfirmation from '../hooks/useShowingExitConfirmation';
var ExitConfirmationMux = function () {
    var opts = useOpts();
    var fireTrackEvent = opts.fireTrackEvent, fireProperEventType = opts.fireProperEventType, updateEventSource = opts.updateEventSource, lastSource = opts.lastSource, exit = opts.exit;
    var setShowingExitConfirmation = useShowingExitConfirmation().setShowingExitConfirmation;
    var handleExit = useCallback(function () {
        fireTrackEvent('Link ExitConfirmation Exit');
        exit();
    }, [fireTrackEvent, exit]);
    var handleCancel = useCallback(function () {
        fireTrackEvent('Link ExitConfirmation Back');
        fireProperEventType(EventAction.EXIT_CANCEL, opts);
        /*
         * Because ExitConfirmation isn't a real screen, we are forced to manually
         * send an updateEventSource and emit an impression event whenever we click
         * "Back". This will revert to the previous source (before the exit
         * confirmation was shown) and emit the impression event from that source.
         */
        updateEventSource(lastSource);
        eventQueue.emit('impression', {});
        setShowingExitConfirmation(false);
    }, [
        fireProperEventType,
        fireTrackEvent,
        lastSource,
        opts,
        setShowingExitConfirmation,
        updateEventSource,
    ]);
    var displayExitScreen = function () {
        return React.createElement(ExitConfirmation, { onBack: handleCancel, onExit: handleExit });
    };
    return displayExitScreen();
};
export default ExitConfirmationMux;
